<div class="flex flex-col flex-auto h-full bg-card w-full">

    <!-- Header -->
        <div class="flex flex-row  justify-between items-center py-3 px-8 border-b">

        <!-- Title -->
            <div class="flex flex-row justify-between w-full">
                <div class="flex items-center gap-3">
                    <button
                        class="md:hidden"
                        mat-icon-button
                        aria-label="Abrir menú"
                        (click)="alternarDrawer()">
                        <mat-icon>menu</mat-icon>
                    </button>
                    <div class="text-2xl font-bold">Catálogos</div>
                </div>
            <mat-radio-group
                aria-label="Seleccionar ciclo"
                [value]="selectedCiclo"
                (change)="onCambioCiclo($event)">
                <mat-radio-button value="basico">Básico</mat-radio-button>
                <mat-radio-button value="diversificado">Diversificado</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

    <mat-drawer-container class="flex-auto h-full w-full bg-card" autosize>
        <mat-drawer
            #matDrawer
            class="w-full md:w-3/12"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            [disableClose]="false">
            <div class="p-4 text-sm text-gray-500" *ngIf="isLoading">Cargando catálogos...</div>
            <div class="p-4 text-sm text-red-600" *ngIf="!isLoading && loadError">{{ loadError }}</div>

            <mat-tree
                [dataSource]="dataSource"
                [treeControl]="treeControl"
                *ngIf="!isLoading && !loadError">

                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                               class="cursor-pointer"
                               (click)="alternarYSeleccionarNodo(node)">
                    <button matIconButton disabled></button>
                    <span [class.font-semibold]="estaSeleccionado(node)" [class.text-primary]="estaSeleccionado(node)">
                        {{ node.name }}
                    </span>
                </mat-tree-node>

                <mat-nested-tree-node *matTreeNodeDef="let node; when: tieneHijos">
                    <div class="mat-tree-node cursor-pointer" matTreeNodePadding
                         (click)="alternarYSeleccionarNodo(node)">
                        <button matIconButton
                                [disabled]="!esNodoRaiz(node)"
                                [attr.aria-label]="'Toggle ' + node.name">
                            <mat-icon class="mat-icon-rtl-mirror" *ngIf="esNodoRaiz(node)">
                                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>
                        <span
                            class="cursor-pointer"
                            [class.font-semibold]="estaSeleccionado(node)"
                            [class.text-primary]="estaSeleccionado(node)">
                            {{ node.name }}
                        </span>
                    </div>
                    <div [class.hidden]="!treeControl.isExpanded(node)" role="group">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                </mat-nested-tree-node>
            </mat-tree>
        </mat-drawer>
        <mat-drawer-content class="flex flex-col min-w-0 h-full p-6">
            <div class="flex w-full items-center justify-between gap-4">
                <div class="flex items-center justify-between gap-3 w-full">
                    <mat-form-field class="w-full fuse-mat-dense rounded-full">
                        <input
                            matInput
                            placeholder="Buscar por descripción, prefijo o correlativo"
                            [(ngModel)]="searchTerm" />
                    </mat-form-field>
                    <button *appControlAcceso="'lectura'" mat-flat-button color="primary" class="mb-3" (click)="abrirModalRegistro()">Agregar</button>
                </div>
            </div>
            <div class="text-lg font-semibold">{{ tableTitle }}</div>

            <div class="text-sm text-gray-500 mb-4" *ngIf="isTableLoading">Cargando datos...</div>

            <div class="overflow-x-auto" *ngIf="!isTableLoading">
                <table mat-table [dataSource]="filteredTableRows" class="w-full min-w-[640px]">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef class="w-20">No.</th>
                        <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
                    </ng-container>

                    <ng-container matColumnDef="descripcion">
                        <th mat-header-cell *matHeaderCellDef>Descripcion</th>
                        <td mat-cell *matCellDef="let row">{{ row.descripcion }}</td>
                    </ng-container>

                    <ng-container matColumnDef="prefijo">
                        <th mat-header-cell *matHeaderCellDef class="w-28">Prefijo</th>
                        <td mat-cell *matCellDef="let row">{{ row.valor1 || '-' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="correlativo">
                        <th mat-header-cell *matHeaderCellDef class="w-32">Correlativo</th>
                        <td mat-cell *matCellDef="let row">{{ row.valor2 || '-' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef class="w-20 text-center">
                            <span *appControlAcceso="'lectura'">Acciones</span>
                        </th>
                        <td mat-cell *matCellDef="let row" class="text-center">
                            <button *appControlAcceso="'lectura'" mat-icon-button [matMenuTriggerFor]="accionesMenu" aria-label="Acciones">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #accionesMenu="matMenu">
                                <button mat-menu-item (click)="abrirModalEdicion(row)">
                                    <mat-icon>edit</mat-icon>
                                    <span>Editar</span>
                                </button>
                                <button mat-menu-item (click)="eliminarCatalogo(row)">
                                    <mat-icon>delete</mat-icon>
                                    <span>Eliminar</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
                </table>
            </div>

            <div class="text-sm text-gray-500 mt-4 text-center" *ngIf="!isTableLoading && filteredTableRows.length === 0">
                No se encontraron resultados.
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>
